module.exports = __webpack_public_path__ + "img/gtl.77c435ed.svg";